<!-- Header section -->
<div class="navbar-container" stickyElement [isNotificationBar]="false">
    <nav class="navbar navbar-expand-sm bg-white shadow-sm nav-main">

        <!-- Toggle Menu-->
        <button id="gprHamburgerMenu" [matMenuTriggerFor]="menu" mat-icon-button>
            <span class="icon_wrapper"><i data-test="gprHamburgerMenu" class="gpr-hamburger-menu"></i></span>
        </button>

        <mat-menu #menu="matMenu" class="hamburger-menu">
            <a id="homeLink" #userPortalLinkEle (click)="checkChangeStatus($event, userPortalLinkEle)"
               class="text-decoration-none" mat-menu-item href="{{userPortalBaseUrl}}">
                <span class="icon_wrapper"><i data-test="homeIcon" class="gpr-portal"></i></span>
                <span data-test="homeLink">{{ 'HEADER.HOME' | translate}}</span>
            </a>
            <a id="myCalculationLink" *ngIf="!isGprGebouwCalculation" #calculationLinkEle (click)="checkChangeStatus($event, calculationLinkEle)"
               class="text-decoration-none" href="{{userPortalBaseUrl + '/dashboard/calculations'}}" mat-menu-item>
                <span class="icon_wrapper"><i data-test="myCalculationIcon" class="gpr-file-management"></i></span>
                <span data-test="myCalculationLink">{{ 'HEADER.MY_CALCULATION' | translate}}</span>
            </a>
            <a id="saveAsCalculation" *ngIf="!isGprGebouwCalculation" #saveAsCalculationLinkEle (click)="saveAsCalculation()"
               class="text-decoration-none" mat-menu-item>
                <span class="icon_wrapper"><i data-test="saveAsCalculationIcon" class="gpr-duplicate"></i></span>
                <span data-test="helpLink">{{ 'HEADER.SAVE_AS' | translate}}</span>
            </a>

            <ng-container *ngIf="calculationAccess$ | async">
                <a id="exportLink" class="text-decoration-none"
                   [class.hidden]="((calculationStatus | async) == 1) ? true : null" (click)="exportCalculation()"
                   mat-menu-item>
                    <span class="icon_wrapper"><i data-test="exportIcon" class="gpr-export"></i></span>
                    <span data-test="exportLink">{{ 'HEADER.EXPORT' | translate}}</span>
                </a>

                <a id="printLink"
                   class="text-decoration-none" [class.disabled]="isDemoLicense"
                   *ngIf="(isExistingBuildingSelected || !isShowIndicatorPage); else submenuTrigger"
                   (click)="printPage('mpg')"
                   mat-menu-item
                   [class.hidden]="((calculationStatus | async) == 1) ? true : null">
                    <span class="icon_wrapper"><i data-test="printIcon" class="gpr-print"></i></span>
                    <span data-test="printLink">{{ 'HEADER.PRINT' | translate }}</span>
                </a>

                <ng-template #submenuTrigger>
                    <a id="printLink"
                       class="text-decoration-none"
                       [matMenuTriggerFor]="printSubMenu"
                       mat-menu-item
                       [class.hidden]="((calculationStatus | async) == 1) ? true : null">
                        <span class="icon_wrapper"><i data-test="printIcon" class="gpr-print"></i></span>
                        <span data-test="printLink">{{ 'HEADER.PRINT' | translate }}</span>
                    </a>
                </ng-template>

                <mat-menu #printSubMenu="matMenu" class="hamburger-menu">
                    <button mat-menu-item (click)="printPage('all')">
                        <span data-test="printSummary">{{ 'HEADER.PRINT_ALL' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="printPage('mpg')">
                        <span data-test="printSummary">{{ 'HEADER.PRINT_MPG' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            (click)="printPage('extraindicators')"
                            *ngIf="(!isExistingBuildingSelected && isShowIndicatorPage)">
                        <span data-test="printDetailed">{{ 'HEADER.PRINT_EXTRA_INDICATOR' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            (click)="printPage('materialpassport')"
                            *ngIf="(!isExistingBuildingSelected && isShowMaterialPassportPage)">
                        <span data-test="printDetailed">{{ 'HEADER.PRINT_MATERIAL_PASSPORT' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            (click)="printPage('materialpassport', true)"
                            *ngIf="(!isExistingBuildingSelected && isShowMaterialPassportPage && isDevMode)">
                        <span data-test="printMaterialPassportPreview">{{ 'HEADER.PRINT_PREVIEW' | translate }}</span>
                    </button>

                </mat-menu>
            </ng-container>

            <a id="helpLink" class="text-decoration-none" target="_blank" href="{{userPortalBaseUrl + '/help/gprmateriaal'}}"
               mat-menu-item>
                <span class="icon_wrapper"><i data-test="helpIcon" class="gpr-questionmark"></i></span>
                <span data-test="helpLink">{{ 'HEADER.HELP' | translate}}</span>
            </a>
            <a id="faqLink" class="text-decoration-none" target="_blank" href="{{userPortalBaseUrl + '/faq/gprmateriaal'}}"
               mat-menu-item>
                <span class="icon_wrapper"><i data-test="faqIcon" class="gpr-comment"></i></span>
                <span data-test="faqLink">{{ 'HEADER.FAQ' | translate}}</span>
            </a>

            <mat-divider></mat-divider>
            <a id="logoutLink" #logoutElem class="text-decoration-none" (click)="logout($event)" mat-menu-item>
                <span class="icon_wrapper"><i data-test="logoutIcon" class="gpr-logout"></i></span>
                <span data-test="logoutLink">{{ 'HEADER.LOGOUT' | translate}}</span>
            </a>
        </mat-menu>

        <!-- TODO: We can create a new component for this and reuse it in multiple places -->
        <!-- Brand -->
        <span class="navbar-brand nav-item pt-2">
            <object type="image/svg+xml" class="logo">
                <strong data-test="gprLogo" class="logo">GPR</strong>
            </object>

            <!-- Watermark container -->
            <ng-template appContainerRef></ng-template>
        </span>

        <ng-container *ngIf="calculationAccess$ | async">
            <!-- Links -->
            <ul class="navbar-nav mx-auto">
                <li class="nav-item">
                    <a data-test="projectCharacteristics" class="nav-link" [routerLinkActiveOptions]="{exact: true}"
                       [routerLink]="['/', urlId,'project-characteristics']"
                       routerLinkActive="active">{{'HEADER.PROJECT_CHARACTERISTICS' | translate}}</a>
                </li>
                <li class="nav-item">
                    <a data-test="buildingCharacteristics" class="nav-link" [routerLinkActiveOptions]="{exact: true}" [class.disabled]="(isProjectPhaseUIEnabled && !isProjectPhasePurposeStatusDataAdded && !isReadOnly)"
                       [routerLink]="['/', urlId,'building-characteristics']" routerLinkActive="active">
                        {{'HEADER.BUILDING_CHARACTERISTICS' | translate}}
                    </a>
                </li>
                <li class="nav-item">
                    <a data-test="components" class="nav-link" [routerLinkActiveOptions]="{ exact: true }" [class.disabled]="(isProjectPhaseUIEnabled && !isProjectPhasePurposeStatusDataAdded && !isReadOnly) || (calculationStatus | async) == 1"
                       [routerLink]="['/', urlId, 'component']"
                       routerLinkActive="active">
                        {{ 'HEADER.COMPONENTS' | translate }}
                    </a>
                </li>
                <li class="nav-item" *ngIf="(!isExistingBuildingSelected && isShowIndicatorPage)">
                    <a data-test="indicators" class="nav-link" [routerLinkActiveOptions]="{ exact: true }" [class.disabled]="(isProjectPhaseUIEnabled && !isProjectPhasePurposeStatusDataAdded && !isReadOnly) || (calculationStatus | async) == 1"
                       [routerLink]="['/', urlId, 'indicators']"
                       routerLinkActive="active">
                        {{ 'HEADER.INDICATORS' | translate }}
                    </a>
                </li>
            </ul>

            <div class="nav-item">
                <a data-test="results" class="nav-link" [routerLinkActiveOptions]="{ exact: true }" [class.disabled]="(isProjectPhaseUIEnabled && !isProjectPhasePurposeStatusDataAdded && !isReadOnly) || (calculationStatus | async) == 1"
                   [routerLink]="['/', urlId, 'result']" routerLinkActive="active">
                    {{ 'HEADER.RESULTS' | translate }}
                </a>
            </div>

            <!-- MPG -->
            <div class="mpg_ppi_wrapper">
                <ng-container *ngIf="(mpgSetting != mpgSettingEnum.score && mpgSetting != mpgSettingEnum.percentages) || ((mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages) && !isExistingBuildingSelected && datasetChoiceId == dataSetSetting.A1A2)"
                              [ngTemplateOutlet]="mpgPillTempRef"></ng-container>

                <ng-container *ngIf="selectedIndicator == indicatorsEnum.MPG">
                    <span data-test="mpg" class="badge rounded-pill"
                          *ngIf="(mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages) && datasetChoiceId != dataSetSetting.A1A2">
                        MPG {{ (isExistingBuildingSelected ? mpgAfter : mpg || 0) | number:'.3-3' | dynamicDecimal: false}}
                    </span>
                </ng-container>

                <!-- PPI -->
                <ng-container *ngIf="selectedIndicator == indicatorsEnum.PPI">
                    <span data-test="ppi" class="badge rounded-pill"
                          *ngIf="(mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages) && datasetChoiceId != dataSetSetting.A1A2">
                        PPI {{ (isExistingBuildingSelected ? ppiAfter : ppi || 0) | number:'.1-2' | dynamicDecimal: false}}
                    </span>
                </ng-container>
            </div>
        </ng-container>

    </nav>
    <nav *ngIf="isReadOnly && showReadonlyBanner" class="readonly-banner navbar navbar-expand-sm">
        <div class="readonly-banner__content">
            <span class="readonly-banner__text">
                {{ 'HEADER.READONLY_MODE_MESSAGE' | translate }}
            </span>
            <span class="icon_wrapper readonly-banner__icon"><i data-test="lockIcon" class="gpr-lock"></i></span>
        </div>
        <button class="readonly-banner__close" (click)="showReadonlyBanner = false" aria-label="Sluiten">&times;</button>
    </nav>
    <div class="nav-sticky-container">
        <nav class="navbar sticky nav-sticky hide-el">
            <!-- MPG and PPI -->
            <ng-container *ngIf="calculationAccess$ | async">
                <ng-container *ngIf="(mpgSetting != mpgSettingEnum.score && mpgSetting != mpgSettingEnum.percentages)  || ((mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages) && !isExistingBuildingSelected && datasetChoiceId == dataSetSetting.A1A2)"
                              [ngTemplateOutlet]="mpgPillTempRef"></ng-container>

                <!-- MPG -->
                <ng-container *ngIf="selectedIndicator == indicatorsEnum.MPG">
                    <span data-test="stickyContainerMpg" class="badge rounded-pill"
                          *ngIf="(mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages) && datasetChoiceId != dataSetSetting.A1A2">
                        MPG {{ (isExistingBuildingSelected ? mpgAfter : mpg || 0) | number:'.3-3' | dynamicDecimal: false}}
                    </span>
                </ng-container>
                <!-- PPI -->
                <ng-container *ngIf="selectedIndicator == indicatorsEnum.PPI">
                    <span data-test="stickyContainerPpi" class="badge rounded-pill"
                          *ngIf="(mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages) && datasetChoiceId != dataSetSetting.A1A2">
                        PPI {{ (isExistingBuildingSelected ? ppiAfter : ppi || 0) | number:'.1-2' | dynamicDecimal: false}}
                    </span>
                </ng-container>
            </ng-container>
        </nav>
    </div>
</div>

<!--Preloading header/footer images for print-->
<div>
    <img class="d-none" src="../../../../assets/img/gpr_materiaal-header.png" alt="" />
    <img class="d-none" src="../../../../assets/img/gpr_materiaal-footer.png" alt="" />
</div>

<ng-template #mpgPillTempRef>
    <ng-container *ngIf="selectedIndicator == indicatorsEnum.MPG; else PPITempRef">
        <div class="current_after_mpg">
            <div data-test="currentMpg" [class.difference_mpg]="mpgSetting == mpgSettingEnum.mpg_difference">
                MPG {{
(mpg || 0)
        | number:'.3-3' | dynamicDecimal: true
                }}
            </div>
            <div data-test="afterMpg" *ngIf="mpgSetting == mpgSettingEnum.current_after || (mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages && datasetChoiceId == dataSetSetting.A1A2)">
                {{(mpgAfter || 0) | number:'.3-3' | dynamicDecimal: true}}
            </div>
            <!-- After - Current = difference -->
            <div data-test="difference" *ngIf="mpgSetting == mpgSettingEnum.mpg_difference">
                {{
(mpgAfter || 0) - (mpg || 0) |
        number:'.3-3'
                }}
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #PPITempRef>
    <div class="current_after_mpg">
        <div data-test="currentPpi" [class.difference_mpg]="mpgSetting == mpgSettingEnum.mpg_difference">
            PPI {{
(ppi || 0) |
            number:'.1-2' | dynamicDecimal
            }}
        </div>
        <div data-test="afterPpi" *ngIf="mpgSetting == mpgSettingEnum.current_after  || (mpgSetting == mpgSettingEnum.score || mpgSetting == mpgSettingEnum.percentages && datasetChoiceId == dataSetSetting.A1A2)">
            {{(ppiAfter || 0) | number:'.1-2' | dynamicDecimal: true}}
        </div>
        <!-- After - Current = difference -->
        <div data-test="difference" *ngIf="mpgSetting == mpgSettingEnum.mpg_difference">
            {{
(ppiAfter || 0) - (ppi || 0) |
            number:'.1-2'
            }}
        </div>
    </div>
</ng-template>